import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'motion/react';
import RotatingText from './RotatingText';
import { Link } from 'react-router-dom';
import CTAButton from './CTAButton';

const CTASection = () => {
    const navigate = useNavigate();
    return (
        <section className="md:py-24">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-6xl flex flex-wrap justify-center items-center gap-x-3 gap-y-2">
                        <RotatingText
                            texts={[
                                'AI',
                                'Design',
                                'OnScript',
                                'Future',
                                'Tech',
                                'Web',
                                'Apps',
                                'Growth'
                            ]}
                            mainClassName="px-3 bg-[#d6fa70] overflow-hidden py-1 justify-center rounded-lg inline-flex"
                            staggerFrom="last"
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "-120%" }}
                            staggerDuration={0.025}
                            splitLevelClassName="overflow-hidden pb-1"
                            transition={{ type: "spring", damping: 30, stiffness: 400 }}
                            rotationInterval={2000}
                        />
                        <span>. Bercastle</span>
                    </h2>
                    <p className="text-xl text-slate-600 max-w-2xl mx-auto mt-6">
                        Let's collaborate to build something extraordinary.
                    </p>
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <CTAButton variant="dark" onClick={() => navigate('/contact')} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
